import { render, staticRenderFns } from "./WorldMap11.vue?vue&type=template&id=67ddabc4&scoped=true"
import script from "./WorldMap11.vue?vue&type=script&lang=js"
export * from "./WorldMap11.vue?vue&type=script&lang=js"
import style0 from "./WorldMap11.vue?vue&type=style&index=0&id=67ddabc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddabc4",
  null
  
)

export default component.exports